import { render, staticRenderFns } from "./BizAgreementinfoModal__Style#Drawer.vue?vue&type=template&id=18d804f2&scoped=true&"
import script from "./BizAgreementinfoModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BizAgreementinfoModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BizAgreementinfoModal__Style#Drawer.vue?vue&type=style&index=0&id=18d804f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d804f2",
  null
  
)

export default component.exports